import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
// DS: i1.2
import React from 'react';
import IconWrap from '../IconWrap';
const CoreIconSmall = (_param)=>/*#__PURE__*/ {
    var { circleClassName  } = _param, props = _object_without_properties(_param, [
        "circleClassName"
    ]);
    return React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "translate(2 2)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("circle", {
        fill: "#EF6D5D",
        cx: "10",
        cy: "10",
        r: "10",
        className: circleClassName
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M10.182 13.75l-3.821 2.009.73-4.255L4 8.491l4.272-.62L10.182 4l1.91 3.871 4.272.62-3.091 3.013.729 4.255z"
    }))));
};
CoreIconSmall.displayName = 'CoreIconSmall';
export default CoreIconSmall;
